<script>
  import { createEventDispatcher } from 'svelte';
  import { pannable } from '../../actions/pannable.js';

  const dispatch = createEventDispatcher();

  const padding = 10;

  let surfaceElement;
  let canvasWidth = 0;
  let canvasHeight = 0;
  let currentX = 0;
  let currentY = 0;
  let pathData = '';
  let minX = Infinity;
  let maxX = 0;
  let minY = Infinity;
  let maxY = 0;
  let pathSegments = [];
  let isDrawing = false;

  function handlePanStart(event) {
    if (event.detail.target !== surfaceElement) {
      isDrawing = false;
      return;
    }

    isDrawing = true;
    canvasWidth = surfaceElement.clientWidth;
    canvasHeight = surfaceElement.clientHeight;

    currentX = Math.max(0, Math.min(canvasWidth, event.detail.x));
    currentY = Math.max(0, Math.min(canvasHeight, event.detail.y));

    minX = Math.min(minX, currentX);
    maxX = Math.max(maxX, currentX);
    minY = Math.min(minY, currentY);
    maxY = Math.max(maxY, currentY);

    pathSegments.push(['M', currentX, currentY]);
    pathData += `M${currentX},${currentY}`;
  }

  function handlePanMove(event) {
    if (!isDrawing) return;

    currentX = Math.max(0, Math.min(canvasWidth, event.detail.x));
    currentY = Math.max(0, Math.min(canvasHeight, event.detail.y));

    minX = Math.min(minX, currentX);
    maxX = Math.max(maxX, currentX);
    minY = Math.min(minY, currentY);
    maxY = Math.max(maxY, currentY);

    pathSegments.push(['L', currentX, currentY]);
    pathData += `L${currentX},${currentY}`;
  }

  function handlePanEnd() {
    isDrawing = false;
  }

  function buildSvgPath(segments, offsetX, offsetY) {
    return segments.reduce((acc, [command, x, y]) => {
      return acc + command + (x + offsetX) + ',' + (y + offsetY);
    }, '');
  }

  function finish() {
    if (!pathSegments.length) return;

    const offsetX = -(minX - padding);
    const offsetY = -(minY - padding);
    const width = maxX - minX + padding * 2;
    const height = maxY - minY + padding * 2;

    dispatch('finish', {
      originalWidth: width,
      originalHeight: height,
      svgPath: buildSvgPath(pathSegments, offsetX, offsetY),
    });
  }

  function cancel() {
    dispatch('cancel');
  }
</script>

<div
  bind:this={surfaceElement}
  use:pannable
  on:panstart={handlePanStart}
  on:panmove={handlePanMove}
  on:panend={handlePanEnd}
  class="relative w-full h-full select-none bg-gray-50">
  <div class="absolute right-6 bottom-6 flex items-center gap-3 glass-dark p-2 rounded-2xl shadow-soft">
    <button
      type="button"
      on:click={cancel}
      class="h-10 px-5 rounded-xl bg-white/10 text-white font-semibold hover:bg-white/20 transition-all btn-hover">
      Cancel
    </button>
    <button
      type="button"
      on:click={finish}
      class="h-10 px-6 rounded-xl bg-indigo-500 text-white font-semibold hover:bg-indigo-400 shadow-glow transition-all btn-hover">
      Done
    </button>
  </div>

  <svg class="w-full h-full pointer-events-none">
    <path
      stroke-width="5"
      stroke-linejoin="round"
      stroke-linecap="round"
      d={pathData}
      stroke="black"
      fill="none" />
  </svg>
</div>
